// This module contains the complete cell customization logic you had originally, converted to pure functions
import { PDF_STYLES } from './pdfStyles';

// eslint-disable-next-line no-unused-vars
export function createCellCustomizer({ formatCellValue }) {
    return function cellCustomizer(options) {
        const excelCell = options.pdfCell || options.excelCell;
        excelCell.font = { size: PDF_STYLES.defaultFontSize };
        excelCell.padding = 1;


        const gridCell = options.gridCell || {};


        if (gridCell.rowType === 'data') {
            if (gridCell.column && gridCell.column.cellTemplate === 'ActiveStatus') {
                if (gridCell.value === 'N' || !gridCell.value) excelCell.value = 'Active';
                else if (gridCell.value === 'Y' || gridCell.value) excelCell.value = 'Inactive';
            } else if (gridCell.column && gridCell.column.dataType === 'datetime') {
                if (gridCell.value)
                    excelCell.value = (typeof gridCell.value.dateWithOffset === 'function')
                        ? (gridCell.value.dateWithOffset().toShortDateString() + ', ' + gridCell.value.dateWithOffset().toShortTimeString())
                        : (new Date(gridCell.value).toLocaleString());
            } else if (gridCell.column && gridCell.column.cellTemplate === 'RadioTemplate') {
                if (gridCell.value === 'N' || !gridCell.value) excelCell.value = 'No';
                else if (gridCell.value === 'Y' || gridCell.value) excelCell.value = 'Yes';
            } else if (gridCell.column && gridCell.column.dataType === 'date' && gridCell.column.format === 'dd MMM yyyy') {
                if (gridCell.value) excelCell.value = new Date(gridCell.value).toLocaleDateString();
            }
        }


        // Percentage / formatting logic
        var pattern = /[%]/g;
        if (gridCell.column && gridCell.column.format) {
            if (gridCell.value) {
                if (pattern.test(gridCell.column.format) && typeof gridCell.value === 'number') {
                    excelCell.value = gridCell.value.toFixed(2) + ' %';
                } else {
                    excelCell.numFmt = gridCell.column.format;
                }


                if (typeof gridCell.value === 'number' && gridCell.value <= 0) {
                    excelCell.font = { color: { argb: PDF_STYLES.negativeColorArgb } };
                    excelCell.numFmt = gridCell.column.format;
                    excelCell.textColor = PDF_STYLES.negativeHex;
                }
            } else {
                if (gridCell.value == 0) {
                    excelCell.value = '-';
                } else {
                    if (gridCell.rowType == 'group' && gridCell.groupSummaryItems) {
                        if (pattern.test(gridCell.column.format))
                            excelCell.value = gridCell.groupSummaryItems[0].value.toFixed(2) + ' %';
                        else {
                            excelCell.numFmt = gridCell.column.format;
                            excelCell.value = gridCell.groupSummaryItems[0].value;
                        }
                        if (gridCell.groupSummaryItems[0].value < 0) {
                            excelCell.font = { color: { argb: PDF_STYLES.negativeColorArgb }, bold: true };
                        } else if (gridCell.groupSummaryItems[0].value == 0) {
                            excelCell.value = '-';
                        }
                    }
                }
            }
        }

        if (excelCell.text) {
            const hasBrTag = /<br\s*\/?>/i.test(excelCell.text);
            if (hasBrTag) {
                excelCell.text = excelCell.text.replace(/<br\s*\/?>/gi, '');
                // Additional '\n' is not requited as this point since text already wraps with '\n' in the text when exporting to PDF. If we add additional '\n' here, it will create extra line breaks in the PDF export. So we can just remove the <br> tags without replacing them with '\n'.
            }
        }


        // group row background
        if (gridCell.rowType === 'group') {
            excelCell.backgroundColor = PDF_STYLES.groupBg;
        }


        excelCell.borderWidth = 0.1;
        excelCell.borderColor = '#ffffff';


        if (gridCell.rowType === 'header') {
            excelCell.font = { bold: true, size: 10, color: { argb: PDF_STYLES.negativeColorArgb } };
            excelCell.backgroundColor = PDF_STYLES.headerBg;
            excelCell.textColor = PDF_STYLES.headerTextColor;
        }


        if (gridCell.rowType === 'group') {
            excelCell.font = { bold: true, size: 9 };


            if (excelCell.value <= 0) {
                excelCell.font = { color: { argb: PDF_STYLES.negativeColorArgb } };
                excelCell.numFmt = gridCell.column ? gridCell.column.format : undefined;
                excelCell.textColor = PDF_STYLES.negativeHex;
            }
        }
    };
}